"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LayoutPagingTable = _interopRequireDefault(require("01_core/components/layout/LayoutPagingTable"));
var _ListIconButton = _interopRequireDefault(require("01_core/components/materials/ListIconButton"));
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _kansaReportActions = require("../kansaReportActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 監査報告書検索画面（検索結果）
 */
const KansaReportSearchResult = function (props) {
  const {
    intl,
    searchResult,
    paging,
    changePage,
    changeViewNum,
    changeScrollTop,
    scrollTop,
    goRegister,
    goRefer,
    goEvRegister,
    goEvRefer,
    search
  } = props;
  const columns = [{
    dataKey: 'hikansabumon',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_HI_KANSA_BUMON
    }),
    width: 20
  }, {
    dataKey: 'kansaKanryoCounts',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_COMPLETE_COUNTS
    }),
    width: 8
  }, {
    dataKey: 'creationStatus',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_REPORT_CREATION_STATUS
    }),
    width: 8
  }, {
    dataKey: 'creationActions',
    label: '',
    width: 6
  }, {
    dataKey: 'evaluationStatus',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_REPORT_EVALUATION_STATUS
    }),
    width: 8
  }, {
    dataKey: 'evaluationActions',
    label: '',
    width: 6
  }];
  const createRow = n => {
    const hikansabumon = n.hikansabumon;
    const kansaKanryoCounts = /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, n.kansaKanryoKensu);
    const creationStatus = getStatusInfo(n.createStatus, n.createDt);
    const registerIcon = n.editable && !n.created ? /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "register",
      action: "register",
      onClick: onRegisterClick(n)
    }) : null;
    const updateIcon = n.editable && n.created ? /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "update",
      action: "update",
      onClick: onUpdateClick(n)
    }) : null;
    const referIcon = !n.editable && n.referable ? /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "detail",
      action: "detail",
      onClick: onReferClick(n)
    }) : null;
    const creationActions = [registerIcon, updateIcon, referIcon];
    const evaluationStatus = getStatusInfo(n.hyokaStatus, n.hyokaDt);
    const evRegisterIcon = n.evaluable && !n.evaluated ? /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "ev-register",
      action: "register",
      onClick: onEvRegisterClick(n)
    }) : null;
    const evUpdateIcon = n.evaluable && n.evaluated ? /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "ev-update",
      action: "update",
      onClick: onEvUpdateClick(n)
    }) : null;
    const evReferIcon = !n.evaluable && n.hyokaReferable ? /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      key: "ev-detail",
      action: "detail",
      onClick: onEvReferClick(n)
    }) : null;
    const evaluationActions = [evRegisterIcon, evUpdateIcon, evReferIcon];
    return {
      hikansabumon,
      kansaKanryoCounts,
      creationStatus,
      creationActions,
      evaluationStatus,
      evaluationActions
    };
  };
  const getStatusInfo = (status, dt) => {
    return /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 1
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, status)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, dt)));
  };
  const onRegisterClick = target => () => {
    goRegister(target, _kansaReportActions.CONTENTS.REGISTER);
  };
  const onUpdateClick = target => () => {
    goRegister(target, _kansaReportActions.CONTENTS.REGISTER);
  };
  const onReferClick = target => () => {
    goRefer(target, _kansaReportActions.CONTENTS.REFER);
  };
  const onEvRegisterClick = target => () => {
    goEvRegister(target, _kansaReportActions.CONTENTS.REGISTER);
  };
  const onEvUpdateClick = target => () => {
    goEvRegister(target, _kansaReportActions.CONTENTS.REGISTER);
  };
  const onEvReferClick = target => () => {
    goEvRefer(target, _kansaReportActions.CONTENTS.REFER);
  };
  return /*#__PURE__*/_react.default.createElement(_LayoutPagingTable.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_SEARCH_RESULT_LIST
    }),
    rowData: searchResult,
    createRow,
    columns,
    paging,
    scrollTop,
    changeViewNum: changeViewNum(_kansaReportActions.CONTENTS.SEARCH),
    changeCurrentPage: changePage(_kansaReportActions.CONTENTS.SEARCH),
    onScroll: changeScrollTop(_kansaReportActions.CONTENTS.SEARCH),
    putTypography: true,
    reload: search
  });
};
const mapStateToProps = state => ({
  searchResult: state.kansaReport.searchResult,
  paging: state.kansaReport.main.paging,
  scrollTop: state.kansaReport.main.scrollTop,
  search: state.kansaReport.search
});
const mapDispatchToProps = dispatch => ({
  goRegister: (entries, previousContent) => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.GO_REGISTER](entries, previousContent)),
  goRefer: (entries, previousContent) => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.GO_REFER](entries, previousContent)),
  goEvRegister: (entries, previousContent) => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.GO_EV_REGISTER](entries, previousContent)),
  goEvRefer: (entries, previousContent) => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.GO_EV_REFER](entries, previousContent)),
  changeScrollTop: key => scrollTop => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.CHANGE_SCROLL_TOP](key, scrollTop)),
  changePage: key => currentPage => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.CHANGE_PAGE](key, currentPage)),
  changeViewNum: key => viewNum => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.CHANGE_VIEW_NUM](key, viewNum))
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(KansaReportSearchResult));